import React, { FC } from 'react';
import { GenExternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import { TypeUserRecord } from '@/lib/api/accountManager/types';
import { TypeSubscriptionRecord } from '@/lib/api/subscriptionManager/types';
import { isGiftedSubscription } from '@/lib/api/subscriptionManager/helpers';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import { TypeAccountSettingsPageTranslations } from '@/utils/translations';

export type GiftsTileProps = {
  t: TypeAccountSettingsPageTranslations;
  user: TypeUserRecord;
  subscriptions: TypeSubscriptionRecord[] | undefined;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
};

const GiftsTile: FC<GiftsTileProps> = ({
  t,
  user,
  subscriptions,
  tile,
  locale,
}) => {
  if (!subscriptions || subscriptions.length === 0) {
    return null;
  }

  const anyGiftSubs = subscriptions?.some(isGiftedSubscription);

  if (!anyGiftSubs) return null;

  const viewGiftsLink = constructLegacyCustomerPortalLink(locale, [
    user.uuid,
    'account-settings',
    'gifts',
  ]);

  return (
    <GenNavTile
      title={tile.title}
      subTitle={tile.subheader}
      description={tile.description}
      titleDecorator={<GenExternalLink href={viewGiftsLink} cta={t.viewCta} />}
    />
  );
};

export default React.memo(GiftsTile);
